import React, { useEffect, useState } from "react";
import { backendApi } from "../../../api/apiService";
import { toast } from "react-toastify";
import { useSelector } from "../../../components/hooks/hooks";
import moment from "moment";
import { MdOutlineDescription } from "react-icons/md";
import { BsCalendar2Date } from "react-icons/bs";
import { FaMapPin, FaRupeeSign, FaShoppingBag } from "react-icons/fa";
import { FcHighPriority } from "react-icons/fc";
import noData from "../../../images/noData.png";
import Pagination from "react-js-pagination";

export default function RequirementHistory({
  setTabIndex,
  setUpdateData = "default",
}) {
  const { userDetails, userData } = useSelector((state) => state.login);
  const [requirementHistory, setRequirementHistory] = useState([]);
  const [searchParams, setSearchParams] = useState("");
  const [offset, setOffset] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [activePage, setActivePage] = useState(0);

  //? Initial UseEffect
  useEffect(() => {
    getRequirementHistory();
    setUpdateData("default");
  }, []);

  //? Function to get requirementHistory
  const getRequirementHistory = (offset = 0) => {
    const api = {
      functionName: "listNewRequirements",
      siteId: userDetails[0].site_id,
      offset,
      max: 10,
      search: String(searchParams),
    };
    backendApi(api).then((response) => {
      if (response.success === "1") {
        setRequirementHistory(response.dataSet);
        setTotalCount(response.totalCount);
      } else {
        toast.error("Something went wrong!!");
      }
    });
  };
  //? Function to format Date
  function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  //?Function to set updateData props
  const updateRequirement = (data) => {
    setTabIndex(0);
    setUpdateData({ ...data, isEdit: true });
  };
  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
    var offset;
    if (pageNumber === "1") {
      offset = "0";
    } else {
      offset = parseInt(pageNumber - 1) * 10;
    }
    getRequirementHistory(Number(offset));
  };
  return (
    <>
      {/* <div className="col-md-12 mt-4">
        <div className="xilliWrap table-wrap">
          <div className="row">
            <div className="col-md-12">
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Sl.No</th>
                      <th>Job Summary</th>
                      <th>No of Opening</th>
                      <th>Project Name</th>
                      <th>Location Name</th>
                      <th>Due Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {requirementHistory.length > 0 ? (
                      <>
                        {requirementHistory.map((o, index) => {
                          return (
                            <tr>
                              <td>{offset + index + 1}</td>
                              <td onClick={() => updateRequirement(o)}>
                                {o.recruitmentSummary}
                              </td>
                              <td>{o.no_of_vacancy}</td>
                              <td>{o.projectName}</td>
                              <td>{o.locationName}</td>
                              <td>
                                {moment(o.due_date).format("DD-MMM-YYYY")}
                              </td>
                            </tr>
                          );
                        })}
                      </>
                    ) : (
                      ""
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <div className="main-container">
        <div className="card main-card">
          <div className="card-body">
            <div className="xilliRight">
              <div className="xilliWrap">
                <>
                  <div className="pagination_main ms-auto">
                    <Pagination
                      activePage={activePage}
                      itemsCountPerPage={10}
                      totalItemsCount={totalCount}
                      pageRangeDisplayed={5}
                      onChange={handlePageChange}
                    />
                  </div>
                  <div className="row mt-5 justify-content-center">
                    {requirementHistory?.length > 0 ? (
                      <div className="col-md-7">
                        {requirementHistory.map((candidate, index) => {
                          return (
                            <div className="crnRes">
                              <div className="row">
                                <div className="col-md-11">
                                  <h4 className="mb-2">
                                    {candidate.recruitmentSummary.replace(
                                      /\\(['"])/g,
                                      "$1"
                                    )}
                                  </h4>
                                  {candidate.recruitmentRemarks !== "" && (
                                    <p className="mb-1">
                                      <span>
                                        <MdOutlineDescription title="Remarks" />{" "}
                                        {candidate.recruitmentRemarks.replace(
                                          /\\(['"])/g,
                                          "$1"
                                        )}{" "}
                                      </span>
                                    </p>
                                  )}
                                  <p>
                                    <span>
                                      Priority :{" "}
                                      {candidate.priority
                                        ? candidate.priority
                                        : " Not Available"}{" "}
                                    </span>
                                    |
                                    <span>
                                      <BsCalendar2Date title="Due Date" />{" "}
                                      {formatDate(candidate.due_date)}{" "}
                                    </span>
                                    |
                                    <span>
                                      Status :{" "}
                                      {candidate.vacancyStatus
                                        ? candidate.vacancyStatus
                                        : " Not Available"}{" "}
                                    </span>
                                  </p>
                                </div>
                              </div>
                              <div className="row crmExp">
                                <div className="col-md-8">
                                  <div className="">
                                    <p className="mb-1">
                                      <span>
                                        {" "}
                                        Package : <FaRupeeSign />{" "}
                                        {candidate.packageValue
                                          ? candidate.packageValue
                                          : 0}
                                      </span>
                                    </p>
                                    <p>
                                      <span>
                                        Project Name:{" "}
                                        {candidate.projectName.replace(
                                          /\\(['"])/g,
                                          "$1"
                                        )
                                          ? candidate.projectName.replace(
                                              /\\(['"])/g,
                                              "$1"
                                            )
                                          : 0}
                                        {"  "}
                                      </span>
                                      |
                                      <FaMapPin title="Location" />{" "}
                                      {candidate.locationName.replace(
                                        /\\(['"])/g,
                                        "$1"
                                      )
                                        ? candidate.locationName.replace(
                                            /\\(['"])/g,
                                            "$1"
                                          )
                                        : "Not Available"}
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div className="crmPost">
                                <div className="row">
                                  <div className="col-md-5">
                                    {/* <p> */}
                                    <p>
                                      Posted on :{" "}
                                      {formatDate(candidate.created_on)}
                                    </p>
                                    {/* | */}
                                    <p>
                                      No of Positions :{" "}
                                      {candidate.no_of_vacancy
                                        ? candidate.no_of_vacancy
                                        : 0}{" "}
                                    </p>
                                    {/* </p> */}
                                  </div>
                                  <div className="col-md-2">
                                    <button
                                      className="btn btn-btn1 btn-btn bg-primary w-100 mb-3"
                                      onClick={() =>
                                        updateRequirement(candidate)
                                      }
                                    >
                                      Edit
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <div className="noHistory d-flex flex-column">
                        <div>
                          <img src={noData} alt="noData" />
                        </div>
                        <div>No History Available</div>
                      </div>
                    )}
                  </div>
                </>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
